import { createGlobalStyle } from 'styled-components';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BANNER_HEIGHT = '2.625rem';

export const StyledBodyPadding = createGlobalStyle(() => ({
    body: {
        paddingTop: BANNER_HEIGHT,
    },
}));

export const StyledTrialBanner = styled(Box)(({ theme }) => ({
    height: BANNER_HEIGHT,
    backgroundColor: '#1e564a',
    color: theme.palette.background.action,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 1.375rem',
    userSelect: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    fontSize: '0.875rem',

    '.telephone-icon': {
        position: 'relative',
        top: '1px',
    }
}));

export const StyledBoldText = styled(Box)(({
    fontWeight: '700',
}));

export const StyledUnderlineLinkText = styled('a')(({
    color: '#DEFF00',
}));

export const StyledLinkText = styled('a')(({
    color: 'inherit',
    textDecoration: 'none',
}));